import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { PageHeader } from '@/components/shared/PageHeader';
import { DepositAddressDialog } from '@/components/features/deposits/DepositAddressDialog';
import { DepositHistoryTable } from '@/components/features/deposits/DepositHistoryTable';
import { DepositFilters } from '@/components/features/deposits/DepositFilters';
import { useDepositHistory } from '@/lib/hooks';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import type {DepositFilters as DepositFiltersType, DepositTransaction} from '@/lib/types';

export const Route = createFileRoute('/_auth/deposits/')({
  component: DepositsComponent,
});

function DepositsComponent() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [filters, setFilters] = useState<DepositFiltersType>({});
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);

  const { data, isLoading } = useDepositHistory({
    ...filters,
    page,
    per_page: perPage,
  });

  return (
    <div className="space-y-6">
      <PageHeader
        title="Депозиты"
        description="Управление входящими депозитами USDT TRC20"
        action={
          <Button onClick={() => setDialogOpen(true)}>
            <Plus className="mr-2 h-4 w-4" />
            Депозит
          </Button>
        }
      />

      <DepositFilters filters={filters} onFiltersChange={setFilters} />

      <DepositHistoryTable
        data={(data?.data || []) as DepositTransaction[]}
        meta={data?.meta}
        isLoading={isLoading}
        page={page}
        perPage={perPage}
        onPageChange={setPage}
        onPerPageChange={setPerPage}
      />

      <DepositAddressDialog open={dialogOpen} onOpenChange={setDialogOpen} />
    </div>
  );
}
